module.exports = __webpack_public_path__ + "img/flame-phone.724b746b.png";